import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'SalesOrder',
    column_type: 'id',
  },
  created_at: {
    model_name: 'SalesOrder',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'SalesOrder',
    column_type: 'datetime',
  },
  number: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  customer: {
    model_name: 'SalesOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  customer_id: {
    model_name: 'SalesOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  kind: {
    model_name: 'SalesOrder',
    column_type: 'enum',
  },
  user: {
    model_name: 'SalesOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'SalesOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  is_transfer_existing: {
    model_name: 'SalesOrder',
    column_type: 'boolean',
  },
  ordered_on: {
    model_name: 'SalesOrder',
    column_type: 'date',
  },
  product_type: {
    model_name: 'SalesOrder',
    column_type: 'enum',
  },
  business_kind: {
    model_name: 'SalesOrder',
    column_type: 'enum',
  },
  source: {
    model_name: 'SalesOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'source',
      model_name: 'SalesOrder',
    },
  },
  source_id: {
    model_name: 'SalesOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'source',
      model_name: 'SalesOrder',
    },
  },
  sales_amount: {
    model_name: 'SalesOrder',
    column_type: 'decimal',
  },
  payment_reminders: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_reminders',
      model_name: 'PaymentReminder',
      foreign_key: 'sales_order_id',
    },
  },
  payment_reminder_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_reminders',
      model_name: 'PaymentReminder',
      foreign_key: 'sales_order_id',
    },
  },
  sales_line_items: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sales_line_items',
      model_name: 'SalesLineItem',
      foreign_key: 'sales_order_id',
    },
  },
  sales_line_item_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sales_line_items',
      model_name: 'SalesLineItem',
      foreign_key: 'sales_order_id',
    },
  },
  jushuitan_orders: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'jushuitan_orders',
      model_name: 'JushuitanOrder',
      foreign_key: 'sales_order_id',
    },
  },
  jushuitan_order_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'jushuitan_orders',
      model_name: 'JushuitanOrder',
      foreign_key: 'sales_order_id',
    },
  },
  tax: {
    model_name: 'SalesOrder',
    column_type: 'decimal',
  },
  cost: {
    model_name: 'SalesOrder',
    column_type: 'decimal',
  },
  profit: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  fully_shipped: {
    model_name: 'SalesOrder',
    column_type: 'boolean',
  },
  sent_jushuitan_orders: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sent_jushuitan_orders',
      model_name: 'JushuitanOrder',
      foreign_key: 'sales_order_id',
    },
  },
  sent_jushuitan_order_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sent_jushuitan_orders',
      model_name: 'JushuitanOrder',
      foreign_key: 'sales_order_id',
    },
  },
  jushuitan_orders_amount: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  jushuitan_orders_real_freight: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  confirmed_jushuitan_after_sales: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'confirmed_jushuitan_after_sales',
      model_name: 'JushuitanAfterSale',
      foreign_key: 'o_id',
    },
  },
  confirmed_jushuitan_after_sale_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'confirmed_jushuitan_after_sales',
      model_name: 'JushuitanAfterSale',
      foreign_key: 'o_id',
    },
  },
  jushuitan_after_sales_amount: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  adjustments: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'adjustments',
      model_name: 'Adjustment',
      foreign_key: 'adjustable_id',
    },
  },
  adjustment_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'adjustments',
      model_name: 'Adjustment',
      foreign_key: 'adjustable_id',
    },
  },
  adjustments_amount: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  remaining_amount: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  receivable_amount: {
    model_name: 'SalesOrder',
    column_type: 'decimal',
  },
  unreceived_receivable_amount: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  payment_allocations: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_allocations',
      model_name: 'PaymentAllocation',
      foreign_key: 'payable_id',
    },
  },
  payment_allocation_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_allocations',
      model_name: 'PaymentAllocation',
      foreign_key: 'payable_id',
    },
  },
  payment_allocations_from_jushuitan_orders: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_allocations_from_jushuitan_orders',
      model_name: 'PaymentAllocation',
      foreign_key: 'payable_id',
    },
  },
  payment_allocations_from_jushuitan_order_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_allocations_from_jushuitan_orders',
      model_name: 'PaymentAllocation',
      foreign_key: 'payable_id',
    },
  },
  received_amount: {
    model_name: 'SalesOrder',
    column_type: 'decimal',
  },
  is_even: {
    model_name: 'SalesOrder',
    column_type: 'boolean',
  },
  finished_on: {
    model_name: 'SalesOrder',
    column_type: 'date',
  },
  remark: {
    model_name: 'SalesOrder',
    column_type: 'text',
  },
  sales_order_allocations_amount: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  sales_order_allocations_as_source: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sales_order_allocations_as_source',
      model_name: 'SalesOrderAllocation',
      foreign_key: 'source_id',
    },
  },
  sales_order_allocations_as_source_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sales_order_allocations_as_source',
      model_name: 'SalesOrderAllocation',
      foreign_key: 'source_id',
    },
  },
  sales_order_allocations_as_target: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sales_order_allocations_as_target',
      model_name: 'SalesOrderAllocation',
      foreign_key: 'target_id',
    },
  },
  sales_order_allocations_as_target_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'sales_order_allocations_as_target',
      model_name: 'SalesOrderAllocation',
      foreign_key: 'target_id',
    },
  },
  after_sale_allocations: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'after_sale_allocations',
      model_name: 'AfterSaleAllocation',
      foreign_key: 'sales_order_id',
    },
  },
  after_sale_allocation_ids: {
    model_name: 'SalesOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'after_sale_allocations',
      model_name: 'AfterSaleAllocation',
      foreign_key: 'sales_order_id',
    },
  },
  can_update: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  can_destroy: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  can_update_finished: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  can_cancel_finished: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
  can_update_cost: {
    model_name: 'SalesOrder',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
